<script setup>
import { ref, inject, onMounted, watch } from 'vue';
import NoDataAutocomplete from '@/components/widgets/NoDataAutocomplete.vue';
const backendApi = inject('backendApi');

const props = defineProps({
    multiple: {
        type: Boolean,
        default: false
    },
    clearable: {
        type: Boolean,
        default: true
    }
});

const selectedItems = ref([]);
const countries = ref([]);
const loading = ref(true);
const searchQuery = ref('');
const showRetryButton = ref(false);

const getCountries = (reset = false) => {
    if (reset) {
        cleanData(); // Limpiar los datos cuando haya un cambio de búsqueda
    }
    backendApi()
        .country()
        .index({
            pattern: searchQuery.value,
            active: true
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        countries.value = response.data.map((item) => ({
            name: item.name,
            id: item.id
        }));
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    countries.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

const handleSearch = () => {
    getCountries(true);
};

onMounted(() => getCountries());

watch(
    searchQuery,
    () => {
        getCountries(true); // Reinicia la búsqueda cada vez que cambia searchQuery
    },
    { immediate: true }
);
</script>

<template>
    <v-select
        v-model="selectedItems"
        :items="countries"
        item-value="id"
        item-title="name"
        :label="$t('Country')"
        :multiple="props.multiple"
        :chips="true"
        :clearable="props.clearable"
        :searchable="true"
        :loading="loading"
        hide-details
        density="compact"
        persistent-clear
        @search="handleSearch"
    >
        <template v-slot:no-data>
            <NoDataAutocomplete
                :loading="loading"
                :show-retry-button="showRetryButton"
                @retry="getCountries"
            ></NoDataAutocomplete>
        </template>
    </v-select>
</template>

<style lang="scss" scoped>
.v-select__selections .v-select__selection {
    margin-inline-end: 0px !important;
}

.v-chip {
    align-items: center;
    border-radius: 16px;
    display: inline-flex;
    height: 32px;
}
</style>
